import { trackDataLayerEvent } from "../../../../../dev/front/js/dataLayer"

const EVENT_NAME = "investment_calculator"
const TRACK_ATTRIBUTE = "data-calculator-event"
// Inputs recalculate while typing, only the value the user settles on should reach Meiro
const PUSH_DELAY_MS = 1500

let pushTimeout = null

export default function initInvestmentCalculator() {
  document.addEventListener("ajaxSnippetUpdate", scheduleTrackingEvent)
}

function scheduleTrackingEvent() {
  const chart = document.querySelector(`[${TRACK_ATTRIBUTE}]`)

  if (!chart) return

  const payload = parsePayload(chart)
  // Unrelated snippet updates must not resend a chart that was already tracked
  chart.removeAttribute(TRACK_ATTRIBUTE)

  if (!payload) return

  clearTimeout(pushTimeout)
  pushTimeout = setTimeout(
    () => trackDataLayerEvent(EVENT_NAME, false, payload),
    PUSH_DELAY_MS
  )
}

function parsePayload(chart) {
  try {
    return JSON.parse(chart.getAttribute(TRACK_ATTRIBUTE))
  } catch {
    return null
  }
}
